module.exports = __webpack_public_path__ + "5c0c24ba1f4be5cb5cb5f871848c9c2f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/rocket-ship-empty.png
// module id = 2863
// module chunks = 0